module.exports = __webpack_public_path__ + "ae547dbec390990657f9d8acd33fbea4.svg";